/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */
window.PXUTheme.jsFeaturedBlogPosts = {
  init: function($section) {
    window.PXUTheme.jsFeaturedBlogPosts = $.extend(this, window.PXUTheme.getSectionData($section));

    const screenWidth = window.innerWidth;
    const shouldRunDesktop = this.use_desktop_slider && screenWidth >= 799;
    const shouldRunMobile = this.use_mobile_slider && screenWidth <= 798;

    console.log("this.use_mobile_slider" + this.use_mobile_slider);

    if (shouldRunDesktop || shouldRunMobile) {
      this.createSlider($section);
    }
  },
  createSlider: function($section) {
    const $prevButton = $section.find('.blog-posts__nav--prev');
    const $nextButton = $section.find('.blog-posts__nav--next');
    const $blogPostsSlider = $section.find('[data-blog-posts-wrapper]');

    const isDesktop = window.innerWidth > 798;

    const $flickitySlider = $blogPostsSlider.flickity({
      initialIndex: isDesktop ? 1 : 0,
      prevNextButtons: this.posts_limit > this.posts_per ? true : false,
      cellAlign: 'center',
      lazyLoad: 2,
      wrapAround: true,
      draggable: true,
      pageDots: this.show_navigation_dots,
      imagesLoaded: true
    });

    $flickitySlider.on('settle.flickity', () => $flickitySlider.flickity('resize'));
    $prevButton.on('click', () => $flickitySlider.flickity('previous'));
    $nextButton.on('click', () => $flickitySlider.flickity('next'));
  },
  unload($section) {
    const $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
    $('.blog-posts__nav--prev').off();
    $('.blog-posts__nav--next').off();
  },
};

/******/ })()
;